import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import template from 'more/templates/LangSelect.html?raw';
import domConstruct from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import on from 'dojo/on';
import lang from 'dojo/_base/lang';

class LangSelect extends compose(_WidgetBaseSP, _TemplatedMixin) {
    [key: string]: any;

    templateString: any = template;

    langs: any = [
        //["it", "it", "Italiano"],
        ["de", "de", "Deutsch"],
        ["en", "gb", "English"]
    ];

    _registry: any = [];

    constructor() {
        super(...(arguments as unknown as []));
        this._registry = [];
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        var i = 0;

        while (i < this.langs.length) {

            var link: any = domConstruct.create("div", {
                style: {
                    //paddingRight: "25px"
                },
                innerHTML: '<i class="flag-icon flag-icon-' + this.langs[i][1] + '" style="margin-right:0.4em"></i>' + this.langs[i][2] + " - " + this.langs[i][1].toUpperCase()
            }, this.dropcontent);

            domClass.add(link, "w3-bar-item");
            domClass.add(link, "mds-hover-dark");

            on(link, "click", lang.hitch(this, "_SwitchLang", link));

            this._registry.push({
                link: link,
                lang: this.langs[i]
            });

            i++;
        }
    }

    _SwitchLang(link: any, e?: any): void {
        var lang = this._getLangByLink(link);
        location.assign("?lang=" + lang[0]);
    }

    _getLangByLink(link: any): any {
        for (var i = 0; i < this._registry.length; i++) {
            if (this._registry[i].link == link) {
                return this._registry[i].lang;
            }
        }

        return null;
    }

    _OpenDropdown(): void {
        if (!domClass.contains(this.dropcontent, "w3-show")) {
            domClass.add(this.dropcontent, "w3-show");
            domClass.replace(this.arrowicon, "fa-angle-up", "fa-angle-down");
            domClass.add(this.dropbutton, "hover");
            //console.debug(this.dropbutton, this.dropbutton.getBoundingClientRect());
            domStyle.set(this.dropcontent, "top", this.dropbutton.getBoundingClientRect().bottom.toString() + "px");
            domStyle.set(this.dropcontent, "left", this.dropbutton.getBoundingClientRect().left.toString() + "px");
        }
        else {
            this._CloseDropdown();
        }
    }

    _CloseDropdown(): void {
        domClass.remove(this.dropcontent, "w3-show");
        domClass.remove(this.dropbutton, "hover");
        this.dropbutton.blur();
        domClass.replace(this.arrowicon, "fa-angle-down", "fa-angle-up");
    }

    mouseLeaveTimeout: any = null;
    onLeave_MainContainer(evt: any): void {
        //this.mouseLeaveTimeout = setTimeout(lang.hitch(this, this._CloseDropdown), 100);
    }

    onEnter_MainContainer(evt: any): void {
        if (this.mouseLeaveTimeout) {
            clearTimeout(this.mouseLeaveTimeout);
            this.mouseLeaveTimeout = null;
        }
    }
}

export default mdsWidget(LangSelect);
